import { FieldNames, isTaxonomyField } from 'v2/core/entities/fields';
import useQueryInspector from 'v2/core/services/queryBuilder/useQueryInspector';
import {
  EmptyWhereClause,
  entityFilter,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';
import { FeedbackMetaData } from 'v2/store/useViewFeedbackStore';

interface useGetSelectedFeedbackMetadataOptions {
  whereClause: WhereClause | undefined;
  labels?: {
    id: string;
    name: string;
    fieldName: FieldNames;
  }[];
}

export function useGetSelectedFeedbackMetadata({
  whereClause,
  labels,
}: useGetSelectedFeedbackMetadataOptions): FeedbackMetaData[] | undefined {
  const entityFilters = (
    useQueryInspector(
      whereClause ?? EmptyWhereClause,
      'Entity',
    ) as entityFilter['entities']
  ).map((metadata) => ({
    id: metadata.entityID,
  })) as FeedbackMetaData[];

  const reasonFilters = useQueryInspector(
    whereClause ?? EmptyWhereClause,
    'Reason',
  ).map((id) => ({
    id,
  })) as FeedbackMetaData[];

  const categoryFilters = useQueryInspector(
    whereClause ?? EmptyWhereClause,
    'Category',
  ).map((id) => ({
    id,
  })) as FeedbackMetaData[];

  const taxonomyLabels =
    labels?.filter((label) => isTaxonomyField(label.fieldName)) ?? [];

  if (taxonomyLabels.length > 0) {
    return taxonomyLabels;
  }

  return whereClause?.op || whereClause?.filter
    ? [
        ...(entityFilters ?? []),
        ...(reasonFilters ?? []),
        ...(categoryFilters ?? []),
      ]
    : undefined;
}
